
(() => {
  const gate = document.querySelector("[data-wah-age-gate]");
  if (!gate) return;

  const key = "whatahoot-age-confirmed";
  if (window.localStorage && localStorage.getItem(key) === "yes") return;

  gate.classList.add("is-visible");

  // Focus the confirm button when the gate opens
  const confirm = gate.querySelector("[data-wah-age-confirm]");
  if (confirm) setTimeout(() => confirm.focus(), 50);

  // Focus trap — keep Tab/Shift+Tab inside the dialog
  const focusable = () =>
    Array.from(gate.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )).filter(el => !el.closest('[hidden]'));

  gate.addEventListener("keydown", (e) => {
    if (e.key !== "Tab") return;
    const els = focusable();
    if (!els.length) return;
    const first = els[0];
    const last = els[els.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  if (confirm) {
    confirm.addEventListener("click", () => {
      try {
        localStorage.setItem(key, "yes");
      } catch (error) {
        // If storage is blocked, still let the customer continue for this page view.
      }
      gate.classList.remove("is-visible");
      // Return focus to body so screen readers re-announce page content
      document.body.focus();
    });
  }
})();
